import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { PresentAnnoncementPresenter } from '@Selectors/builder/PresentAnnoncementPresenter';
import { CloseButton, Col, Row } from 'reactstrap';
import { container } from '@Container';
import { AnnoncementAction } from '@Redux/actions';
import { TYPES } from '@Types';

const AnnoncementComponent: React.FC<Props> = ({ annoncement, hidde }) => {
  if (!annoncement)
    return (<></>);

  return (
    <Row className="justify-content-center">
      <Col xs={12} md={10} xl={8} lg={8} className="annoncement">
        <CloseButton className='btn btn-lg float-end' onClick={() => hidde(annoncement.id)} />
        <h2 className="text-center"><i className="fas fa-exclamation-triangle red"></i>{annoncement.title}<i
          className="fas fa-exclamation-triangle red"></i></h2>
        <em dangerouslySetInnerHTML={{ __html: annoncement.content }}></em>
        <div className="text-end">
          <small><i>{annoncement.publishedAt}</i></small>
        </div>
      </Col>
    </Row>
  );
};

const mapStateToProps = (state: AppState) => ({
  annoncement: PresentAnnoncementPresenter(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<AnnoncementAction>(TYPES.Actions.User.AnnoncementAction);

  return {
    hidde: (annoncementId: number) => dispatch(action.hidde(annoncementId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnoncementComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
